module.exports = __webpack_public_path__ + "img/Opened.16d32c23.svg";